import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { StatBlockComponent } from '@rma/dashboard/generic/ui/stat-block';
import type { ConvertedReviewInsights, DateComparisonStat } from '@rma/dashboard/reviews/public/api-reviews-pangea';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { round } from 'lodash-es';
import { ComparisonStatComponent } from '../ui-comparison-stat/comparison-stat.component';

@Component({
  selector: 'rma-my-subscription-google-card',
  imports: [RmaIconComponent, TranslocoModule, ComparisonStatComponent, StatBlockComponent],
  templateUrl: './my-subscription-google-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('subscriptions')],
})
export class MySubscriptionGoogleCardComponent implements OnChanges {
  @Input()
  public insights: ConvertedReviewInsights | null = null;

  @Input()
  public profileOwnerName: string | null = null;

  public comparisonValue?: DateComparisonStat;
  public singleValue = 0;
  public isComparison = false;

  ngOnChanges(): void {
    if (this.insights) {
      const ratingDidImprove = round(this.insights.averageRating?.end ?? 0, 1) > round(this.insights.averageRating?.start ?? 0, 1);
      if (ratingDidImprove) {
        this.isComparison = true;
        this.comparisonValue = this.insights.averageRating;
      } else {
        this.isComparison = false;
        this.singleValue = this.insights?.averageRating?.end ?? 0;
      }
    }
  }
}
